module.exports = __webpack_public_path__ + "img/cjmb1.d4cfa54a.png";